import en from './en'
import cn from './cn'
import tw from './tw'
export const Lang = {
    en,cn,tw
}
export const list = [
    {
        tit:'English',
        val:'en'
    },
    {
        tit:'简体中文',
        val:'cn'
    },
    {
        tit:'繁體中文',
        val:'tw'
    },
]
